import React, { useContext } from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  HashRouter
} from "react-router-dom";
import UserContext from './contexts/UserContext';
import Login from './components/Authentication/Login';
import Home from './components/ZoneCoordinator/Home';
import ZoneRequests from './components/ZoneCoordinator/Requests';
import CreateRequest from './components/ZoneCoordinator/createRequest';
import CheckList from './components/ZoneCoordinator/checklist';
import OpenRequest from './components/ZoneCoordinator/OpenRequest';
import Stock from './components/ZoneCoordinator/stock';
import ItemInPage from './components/ZoneCoordinator/ItemIn';
import ItemOutPage from './components/ZoneCoordinator/ItemOutPage';
import CreateMiqaatModule from './components/ZoneCoordinator/CreateMiqaat';
import ViewMiqaats from './components/ZoneCoordinator/ViewMiqaats';
import OpenMiqaat from './components/ZoneCoordinator/OpenMiqaat';
import ReturnItemMiqaat from './components/ZoneCoordinator/ReturnItemMiqaat';
import AddItem from './components/Central/AddItem';
import AddCoordinator from './components/Central/AddCoordinator';
import AddSupplier from './components/Central/AddSupplier';
import AddUser from './components/Central/AddUser';
import Header from './components/Navigation/Header';
import Footer from './components/Navigation/Footer';
import CentralHome from './components/Central/Home';
import ListItems from './components/Central/ListItems';
import ListSuppliers from './components/Central/ListSuppliers';
import SupplierDetails from './components/Central/SupplierDetails';
import Requests from './components/Central/Requests';
import Logout from './components/Authentication/Logout';
import SupplierList from './components/Central/SupplierList';
import SupplierHome from './components/Supplier/SupplierHome';
import SupplierApprove from './components/Supplier/SupplierApprove';
import SupplierDispatch from './components/Supplier/SupplierDispatch';
import SupplierListItems from './components/Supplier/SupplierListItems';
import ZoneSupplierList from './components/ZoneCoordinator/ZoneSupplierList';
import SupplyApproval from './components/Central/SupplyApproval';
import SupplyDispatch from './components/Central/SupplyDispatch';
import AddZoneSupplier from './components/ZoneCoordinator/AddZoneSupplier';
import UploadItem from './components/Central/UploadItem';
import MainHome from './components/Authentication/Home';
import ListZoneSuppliers from './components/ZoneCoordinator/ListZoneSuppliers';
import UserProfile from './utils/UserProfile';
import AddItemInSupplier from './components/Central/AddItemInSupplier';
import CreateDish from './components/Central/CreateDish';
import CreateMenu from './components/Central/CreateMenu';
import ZoneMenuCreation from './components/ZoneCoordinator/ZoneMenuCreation';
import ListDishes from './components/Central/ListDishes';
import DishDetails from './components/Central/DishDetails';
import ListMenus from './components/Central/ListMenu';
import MenuDetails from './components/Central/MenuDetails';
import PurchaseOrder from './components/Central/PurchaseOrder';
import CreatePurchaseOrder from './components/Central/CreatePurchaseOrder';
import PoDetails from './components/Central/PoDetails';
import PurchaseOrderPrint from './components/Central/print';
import UploadDish from './components/Central/UploadDish';
import ShowBills from './utils/ShowBills';
import MasterPoDetails from './components/Central/MasterPODetails';
import MasterPurchaseOrderPrint from './components/Central/MasterPOPrint';
import EditPurchaseOrder from './components/Central/EditPurchaseOrder';
import Reports from './components/Report/Reports';
import SilatItems from './components/Silat/SilatItems';
import SilatDashboard from './components/Silat/SilatDashboard';
import CommitmentsDisplay from './components/Silat/SilatCommitment';
import UpdateZabihatCommitment from './components/Silat/UpdateZabihatCommitment';
import UpdateCommitment from './components/Silat/UpdateCommitment';
import ManageSilatItems from './components/Silat/ManageSilatItems';
import ManageZabihat from './components/Silat/ManageZabihat';
import ManageJamiats from './components/Silat/ManageJamiats';
import AddSilatViewerUser from './components/Silat/AddSilatViewerUser';
import PrivateRoute from './components/Authentication/PrivateRoute';
import DecryptionHandler from './components/Authentication/Authenticate';
import SendToZone from './components/Central/SendToZone';
import CentralRequests from './components/Central/CentralRequests';
import CentralOpenRequest from './components/Central/CentralOpenRequest';
import SuperAdminHome from './components/SuperAdmin/SuperAdminHome';
import CreateCity from './components/SuperAdmin/CreateCity';
import ChangePassword from './components/SuperAdmin/ChangePassword';
import LogisticsHome from './components/Logistics/LogisticsHome';
import AddLogisticsUser from './components/Logistics/AddLogisticsUser';

const App = () => {
  const {user} = useContext(UserContext);


  const design = (
    <>
      <BrowserRouter>
        <div className="wrapper">
          <div className="min-h-screen flex flex-col">
            <Header />
            <div className={`flex-grow pb-21 overflow-y-auto bg-gray-100 ${user?.role === 'SuperAdmin' && user?.tenant ? 'pt-[124px]' : 'pt-[92px]'}`}>
              <Routes>
              <Route exact path='/' element={<MainHome />} />
                <Route exact path='/login' element={<Login />} />

                <Route exact path='/amalat/authentication' element={<DecryptionHandler />} />

                {(user && user.role === "Zone Coordinator") ? <Route exact path='/zc/home' element={<Home />} /> : null}

                <Route exact path='/zc/home/request' element={<ZoneRequests />} />
                <Route exact path='/zc/stock' element={<Stock />} />
                <Route exact path='/zc/add-zoneSupplier' element={<AddZoneSupplier />} />
                <Route exact path='/zc/create-request' element={<ZoneMenuCreation />} />
                <Route exact path='/zc/create-items-request' element={<CreateRequest />} />
                <Route exact path='/zc/item-in' element={<ItemInPage />} />
                <Route exact path='/zc/item-out' element={<ItemOutPage />} />
                <Route exact path='/central/send-to-zone' element={<SendToZone />} />
                <Route exact path='/zc/checklist' element={<CheckList />} />
                <Route exact path='/zc/checklist/assignSupplier' element={<ZoneSupplierList />} />
                <Route exact path='/zc/open-request' element={<OpenRequest />} />
                <Route exact path='/zc/create-miqaat' element={<CreateMiqaatModule />} />
                <Route exact path='/zc/view-miqaats' element={<ViewMiqaats />} />
                <Route exact path='/zc/open-miqaat' element={<OpenMiqaat />} />
                <Route exact path='/zc/return-item-from-miqaat' element={<ReturnItemMiqaat />} />
                
                <Route exact path='/profile' element={<UserProfile />} />
                <Route exact path='/zc/add-ZoneSupplier' element={<AddZoneSupplier />} />
                {/* Suppliers MENUS */}
                <Route exact path='/add-item' element={<AddItem />} />
                <Route exact path='/upload-item' element={<UploadItem />} />
                <Route exact path='/upload-dish' element={<UploadDish />} />
      
                <Route exact path='/add-coordinator' element={<AddUser />} />
                <Route exact path='/add-supplier' element={<AddSupplier />} />
                {/* <Route exact path='/add-zone' element={<AddZone/>} /> */}
                {/* <Route exact path='/add-user' element={<AddUser/>} /> */}
                <Route exact path='/central/home' element={<CentralHome />} />
                <Route exact path='/central/home/zone' element={<Requests />} />
                <Route exact path='/central/items' element={<ListItems />} />
                <Route exact path='/central/suppliers' element={<ListSuppliers />} />
                <Route exact path='/central/supplier-details' element={<SupplierDetails />} />
                <Route path="/central/supplier-details/addItems" element={<AddItemInSupplier />} />
                {/* <Route exact path='/inventory-list' element={<InventoryList items={inventoryItems} />} /> */}
                {/* <Route exact path='/assignSupplier' element={<AssignSupplier />} /> */}
                <Route exact path='/central/home/zone/assignSupplier' element={<SupplierList />} />
                <Route exact path='/central/supplyapproval' element={<SupplyApproval />} />
                <Route exact path='/central/dispatch' element={<SupplyDispatch />} />
                <Route exact path='/central/create-dish' element={<CreateDish />} />
                <Route exact path='/central/create-menu' element={<CreateMenu />} />
                <Route exact path='/central/dishes' element={<ListDishes />} />
                <Route path="/central/dish/:id" element={<DishDetails />} />
                <Route exact path='/central/menu' element={<ListMenus />} />
                <Route exact path='/central/menu/:id' element={<MenuDetails />} />
                <Route exact path='/central/po' element={<PurchaseOrder />} />
                <Route exact path='/central/create-po' element={<CreatePurchaseOrder />} />
                <Route exact path='/central/po/:id' element={<PoDetails />} />
                <Route path="/central/po/edit/:id" element={<EditPurchaseOrder />} />
                <Route exact path='/central/masterPo/:id' element={<MasterPoDetails />} />
                <Route exact path='/central/po/print' element={<MasterPurchaseOrderPrint />} />
                {/* <Route path="/central/po/print" element={<PurchaseOrder />} /> */}

                <Route exact path='/central/requests' element={<CentralRequests />} />
                <Route exact path='/central/open-request' element={<CentralOpenRequest />} />

                <Route exact path='/supplier/home' element={<SupplierApprove />} />
                <Route exact path='/supplier/home/supplyItem' element={<SupplierHome />} />
                <Route exact path='/supplier/dispatch' element={<SupplierDispatch />} />
                <Route exact path='/supplier/items' element={<SupplierListItems />} />
                <Route exact path='/logout' element={<Logout />} />
                <Route exact path='zc/home/zoneSuppliers' element={<ListZoneSuppliers/>}/>
                <Route exact path='zc/home/show-bills' element={<ShowBills/>}/>
                <Route exact path='central/home/show-bills' element={<ShowBills/>}/>
                <Route exact path='reports' element={<Reports/>}/>

                <Route exact path='silat/home' element={<SilatItems/>}/>
                <Route exact path='silat/silatdash' element={<SilatDashboard/>}/>
                <Route exact path='silat/commitments' element={<CommitmentsDisplay/>}/>
                <Route exact path='silat/commitments/edit/:id' element={<UpdateCommitment/>}/>
                <Route exact path='silat/commitments/zabihat/edit/:id' element={<UpdateZabihatCommitment/>}/>
                <Route exact path='silat/items/manage' element={<ManageSilatItems/>}/>
                <Route exact path='silat/zabihat/manage' element={<ManageZabihat/>}/>
                <Route exact path='silat/jamiats/manage' element={<ManageJamiats/>}/>
                <Route exact path='/add-silat-viewer-user' element={<AddSilatViewerUser/>}/>

                <Route exact path='/superadmin/home' element={<SuperAdminHome />} />
                <Route exact path='/superadmin/create-city' element={<CreateCity />} />
                <Route exact path='/superadmin/change-password' element={<ChangePassword />} />

                <Route exact path='/logistics/home' element={<LogisticsHome />} />
                <Route exact path='/add-logistics-user' element={<AddLogisticsUser />} />

              </Routes>
              {!(user?.role === "Silat") ? <div style={{ height: '120px' }}></div> : null}
            </div>
            <Footer />
          </div>
        </div>
      </BrowserRouter>
    </>
  )
  return design;
}

export default App;